export default {
  NATURAL: '1',
  LEGAL: '2'
}
